import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';
import { UsgService } from 'src/app/usg.service';
import { LoginService } from 'src/app/login.service';
import { PathologyService } from 'src/app/pathology.service';
import { HttpClient } from '@angular/common/http';
import { MedicationService } from 'src/app/medication.service';
import { Exam } from '../../interfaces/exams.service/types'
import { SignatureService } from 'src/app/signature.service';
import { PatientsService } from 'src/app/patients.service';
import { PdfprintService } from 'src/app/pdfprint.service';

@Component({
    selector: 'app-gastro-summary',
    templateUrl: './gastro-summary.component.html',
    styleUrls: ['./gastro-summary.component.scss'],
    standalone: false
})
export class GastroSummaryComponent implements OnInit {
  @Input() signOnly: boolean = false;
  // Hide the inline Sign Exam box when the parent renders the signature itself.
  @Input() hideSignature: boolean = false;
  // Hide the Referring Doctor / Procedure Results column when the parent renders them itself.
  @Input() hideRefDocAndResults: boolean = false;
  formLoadedSub = new Subscription();
  showPrintOpts: boolean = false;
  signed:Date;
  signer:String;
  recoverySTR:string =`המטופל משתחרר כשהוא מתמצא בזמן ובמקום, רפלקס בליעה ושיעול שמורים\nמצב המודינמי יציב, ללא בחילות הקאות או כאבי בטן משמעותיים.`
  dissmissionSTR=`יש לחזור הביתה בליווי, למנוחה של מספר שעות עקב קבלת הטשטוש חל איסור מוחלט על נהיגה בשמונה השעות הקרובות\nבמידה ויופיעו כאבי בטן,חום,הקאות או דימום רקטלי משמעותי ביממה שלאחר הבדיקה יש לפנות לרופא המבצע בטל: 04-6191885\nבמידה ולא ניתן ליצור קשר יש לפנות לחדר מיון עם מכתב זה`
  pathologyError=false
  xmlMode
  xmlLoading=false;
  labelPrinted=false;
  refDocList: string[] = [];
  newRefDoc: string = '';
  loadingRefDocs = false;

  constructor(
    public gastroService: UsgService,
    public medicationService: MedicationService,
    public atS: AutotextService,
    public es: ExamsService,
    public ls: LoginService,
    private http: HttpClient,
    public signatureService: SignatureService,
    public patientService: PatientsService,
    public pdfService: PdfprintService,
    public pathologyService: PathologyService
  ) {}

  ngOnInit() {
   // If signOnly mode, skip all the form initialization logic
   if (this.signOnly) {
     return;
   }
   
   if(this.ls.GID=='113'){
    this.dissmissionSTR=`יש לחזור הביתה בליווי, למנוחה של מספר שעות עקב קבלת הטשטוש חל איסור מוחלט על נהיגה בשמונה השעות הקרובות\nבמידה ויופיעו כאבי בטן,חום,הקאות או דימום רקטלי משמעותי ביממה שלאחר הבדיקה יש לפנות לרופא המבצע בטל: 03-5008854\nבמידה ולא ניתן ליצור קשר יש לפנות לחדר מיון עם מכתב זה`

   }

    if(this.gastroService.gastroForm.get('Recovery').value == null || this.gastroService.gastroForm.get('Recovery').value == '' ){
      this.gastroService.gastroForm.get('Recovery').setValue(this.recoverySTR, {emitEvent:false})
    }
    if(this.gastroService.gastroForm.get('Dissmission').value == null || this.gastroService.gastroForm.get('Dissmission').value == ''){
      this.gastroService.gastroForm.get('Dissmission').setValue(this.dissmissionSTR, {emitEvent:true})
    }
    
    // Load Macabi exam data on init
    this.loadMaccabiExamData();
    
    // Set up a check to load data after a delay (in case maccabiExams loads after ngOnInit)
    setTimeout(() => {
      if(this.ls.maccabiExams && this.gastroService.awlForm.get('HMOExamCode')?.value) {
        this.loadMaccabiExamData();
      }
    }, 500);
    
    this.loadRefDocs();
    if(this.es.isClosed){
      this.gastroService.getClosing().subscribe((d:any) => {
        this.signed = d.ClosedDate;
        this.signer = this.ls.getUserName();
      })
    }
    // if(!this.formLoadedSub){
      this.formLoadedSub = this.es.formLoaded$.subscribe(()=>{
        if(this.gastroService.gastroForm.get('Dissmission').value == null || this.gastroService.gastroForm.get('Dissmission').value == ''){
          this.gastroService.gastroForm.get('Dissmission').setValue(this.dissmissionSTR)
        }

      });
      
      
  }
  
  loadMaccabiExamData() {
    const code = this.gastroService.awlForm.get('HMOExamCode')?.value;
    let name = this.gastroService.awlForm.get('HMOExamName')?.value;

    if (code && this.ls.maccabiExams) {
      let exam = null;
      // First, try to find an exact match for both code and name
      if (name) {
        exam = this.ls.maccabiExams.find(e => e.code == code && e.exam_name == name);
      }

      // If no exact match is found, fall back to matching by code only
      if (!exam) {
        const fallbackExam = this.ls.maccabiExams.find(e => e.code == code);
        if (fallbackExam) {
          // We found a match by code, so we'll use its name
          exam = fallbackExam;
          name = fallbackExam.exam_name;
        }
      }
      
      // If we found an exam by either method, update the form control
      if (exam) {
        this.gastroService.awlForm.get('HMOExamName').setValue(name, { emitEvent: false });
      }
    }
  }

  signClose(){
    this.gastroService.signExam(this.ls.getUserName()).subscribe((d)=>{
      this.signer = this.ls.getUserName();
      this.signed = new Date();
      this.gastroService.gastroForm.disable({emitEvent: false});
      this.es.isClosed = true;
    },(error)=>{
      console.log(error);
    })
  }

 async signExam(showPrint: boolean = false) {
    const examId = this.es.examID;
    const data = {
      signedBy: this.ls.getUserName(),
      signedDate: new Date(),
    };

    try {
      this.http.post(`/api/newExams/signature/sign/${examId}`, data)
      .subscribe((data: Exam) => {
            const printLanguage = "he-IL"; 
            if (showPrint) {
              this.es.exitExam();
              this.gastroService.gastroForm.disable({emitEvent:false})
              this.medicationService.Medication.disable({emitEvent:false})
              this.pathologyService.pathologyForm.disable({ emitEvent: false });
              this.es.examSigned$.next(data);
              this.showPrintOpts = true;
            } else {
              this.es.exitExam();
              this.gastroService.gastroForm.disable({ emitEvent: false });
              this.medicationService.Medication.disable({ emitEvent: false });
              this.pathologyService.pathologyForm.disable({ emitEvent: false });
              this.es.isClosed = true;
              this.showPrintOpts = false;
              this.es.examSigned$.next(data);
              this.http
                .get(
                  `/api/printpdf/${this.es.examID}/${
                    this.es.patServ.getPat().PID
                  }/${printLanguage}/${this.pdfService.printCharts ? "y" : "n"}/${
                    this.pdfService.printImages ? "y" : "n"
                  }/${this.pdfService.Style}/${this.pdfService.perPage}/n`
                )
                .subscribe(
                  () => {},
                  (error) => {
                    console.log(error);
                  }
                );
            }
        });
    } catch (error) {
      console.log(error);
    }
  }

  
  closePreview(event$: string) {
    if (event$ === "sign") {
      this.signExam(false);
    } else if (event$ === "signShowPrint") {
      this.signExam(true);
    }
    this.showPrintOpts = false;
  }

  async printPathologyForm() {
    let printUrl: string;
    let autoIndex;
    this.pathologyError = false;
    if(!this.gastroService.gastroForm.get('Reasone').value){
     return this.pathologyError=true
    }

    // Check if no samples have been taken
    if (!this.pathologyService.pathologies || this.pathologyService.pathologies.length === 0) {
      this.pathologyError = true;
      return;
    }

    if (this.es.examID) {
      autoIndex = this.es.examID
      printUrl = `api/gastro/pathologyFormPrint/${autoIndex}`;
      window.open(printUrl);
    } 
    return

  }

  ngOnDestroy() {
    if (this.formLoadedSub) {
      this.formLoadedSub.unsubscribe();
    }
  }

  downloadXml(examId=this.es.examID, xmlMode=this.xmlMode): void {
    if (!examId || !xmlMode) return;
    this.xmlLoading=true
    this.es.xmlDownloadByExamId(examId, xmlMode).subscribe((xml: any) => {
      const blob = new Blob([xml], { type: 'application/xml' });
      const fileName=this.massageID()+xmlMode
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName}.xml`;
      link.click();
      this.xmlLoading=false
    }),
    (error: any) => {
      console.error('Error downloading XML:', error);
      this.xmlLoading = false;
      // You may add additional error handling if needed
    };
  }

   massageID=(examId=this.es.examID,patId=this.patientService.getPat().ID)=>{
    let examCode = examId.toString(32);


    return `${patId}${examCode}`
}


  loadRefDocs() {
    const clinicId = this.ls.GID || this.ls.ClinicID;
    this.loadingRefDocs = true;
    this.gastroService.getDropdownOptions(clinicId, 'ReffDoc').subscribe({
      next: (options: string[]) => {
        this.refDocList = options || [];
        const current = this.gastroService.gastroForm.get('ReffDoc').value;
        if (current && !this.refDocList.includes(current)) {
          this.refDocList.push(current);
        }
        this.loadingRefDocs = false;
      },
      error: () => { this.loadingRefDocs = false; }
    });
  }

  addRefDoc() {
    const newValue = this.newRefDoc && this.newRefDoc.trim();
    if (!newValue || this.refDocList.includes(newValue)) return;
    const clinicId = this.ls.GID || this.ls.ClinicID;
    this.loadingRefDocs = true;
    this.gastroService.addDropdownOption(clinicId, 'ReffDoc', newValue).subscribe({
      next: () => {
        this.refDocList.push(newValue);
        this.gastroService.gastroForm.get('ReffDoc').setValue(newValue);
        this.newRefDoc = '';
        this.loadingRefDocs = false;
      },
      error: () => { this.loadingRefDocs = false; }
    });
  }

  deleteRefDoc(value: string) {
    const clinicId = this.ls.GID || this.ls.ClinicID;
    this.gastroService.deleteDropdownOption(clinicId, 'ReffDoc', value).subscribe({
      next: () => {
        this.refDocList = this.refDocList.filter(v => v !== value);
        if (this.gastroService.gastroForm.get('ReffDoc').value === value) {
          this.gastroService.gastroForm.get('ReffDoc').setValue('');
        }
      },
      error: () => {}
    });
  }

  setExamName($event){
    const selectedExamName = $event.target.value;
    
    if (!selectedExamName || selectedExamName === '' || !this.ls.maccabiExams) {
      this.gastroService.awlForm.get('HMOExamCode').setValue(null);
      return;
    }
    
    // Find the exam by exam_name
    const exam = this.ls.maccabiExams.find(e => e.exam_name === selectedExamName);
    if (exam) {
      this.gastroService.awlForm.get('HMOExamCode').setValue(exam.code);
    }
  }

secondCommitment(){
if (this.gastroService.awlForm.get('ExamCode').value === 'Gastro-Colonoscopy' && this.es.ExamType === 'Colonoscopy' && this.gastroService.awlForm.get('HMO').value == 'Clalit' ){
  return true
}
if (this.gastroService.awlForm.get('ExamCode').value === 'Gastro-Sigmo' && this.es.ExamType === 'Sigmoidoscopy' && this.gastroService.awlForm.get('HMO').value == 'Clalit' ){
return true
}
return false
}
}
